import React, { useEffect, useState, useMemo } from "react";
import styles from "./NotificationPopup.module.css";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../../../Firebase";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { history } from "../../../history";
import storageService from "../../../services/storageServices";
import { addOrUpdateFcmIdApi } from "../../../services/newServices";
import notificationSound from "../../../assets/sounds/notification_sound.wav";

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);
const getTokenId = async (setFcmId) => {
  return getToken(messaging, {
    vapidKey:
      "BADk7GU_KEzGna4vubbEEYSmEbXL0y27zbEGaZF3DqPCr_kc-wuccl4KypQYLfjQyFuGO6EtiXPb7LCxtGdqBVs",
  })
    .then((currentToken) => {
      if (currentToken) {
        setFcmId(currentToken);
      }
    })
    .catch((err) => {
      // console.log("An error occurred while retrieving token. ", err);
    });
};

const NotificationPopup = () => {
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({ title: "", body: "" });
  const [fcmId, setFcmId] = useState("");

  const sound = useMemo(() => new Audio(notificationSound), []);

  getTokenId(setFcmId);

  const handleShow = () => {
    setShow(true);
  };

  const navigateToBookings = () => {
    history.push("/bookings");
  };

  const onMessageListener = () =>
    new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    });

  const showNotificationOnTab = () => {
    const currentTitle = document.title;
    document.title = "New Booking Recieved";
    const link = document.querySelector("link[rel~='icon']");
    const currentIcon = link.href;
    const redDotIcon =
      "https://hotelzify-dev-images-bucket.s3.ap-south-1.amazonaws.com/circle-area-blue-point-angle-circle-png-file-cd10c54d85143593d1a879e861333633.png";
    let flag = true;
    const iconInterval = setInterval(() => {
      if (flag) {
        link.href = redDotIcon;
      } else {
        link.href = currentIcon;
      }
      flag = !flag;
    }, 250);
    setTimeout(() => {
      document.title = currentTitle;
      clearInterval(iconInterval);
      link.href = currentIcon;
    }, 8000);
  };

  onMessageListener()
    .then((payload) => {
      handleShow();
      setNotification({
        title: payload.notification.title,
        body: payload.notification.body,
      });
      sound.pause();
      sound.currentTime = 0;
      sound.play();
      showNotificationOnTab();
    })
    .catch((err) => {
      console.log("Error while on message listening", err);
    });

  const handleClose = () => {
    setShow(false);
  };

  const stopSoundOnInteraction = () => {
    sound.pause();
    sound.currentTime = 0;
  };

  useEffect(() => {
    if (fcmId) {
      const storedFcmId = storageService.get("fcmId");
      const token = storageService.get("token");

      if (!token) {
        return;
      }

      if (fcmId !== storedFcmId) {
        (async () => {
          await addOrUpdateFcmIdApi({
            fcmId: fcmId,
            deviceType: "website",
          });
          storageService.set("fcmId", fcmId);
        })();
      }
    }
  }, [fcmId]);

  useEffect(() => {
    const channel = new BroadcastChannel("test");
    channel.onmessage = (event) => {
      sound.pause();
      sound.currentTime = 0;
      sound.play();
      showNotificationOnTab();
    };

    document.addEventListener("mousedown", stopSoundOnInteraction);
    document.addEventListener("keydown", stopSoundOnInteraction);

    return () => {
      channel.close();
      document.removeEventListener("mousedown", stopSoundOnInteraction);
      document.removeEventListener("keydown", stopSoundOnInteraction);
    };
  }, []);

  return !show ? null : (
    <div className={styles.container}>
      <div className={styles["notification-text"]}>Notification</div>
      <div className={styles.header} onClick={navigateToBookings}>
        {notification?.title}
      </div>
      <div className={styles.content} onClick={navigateToBookings}>
        {notification?.body}
      </div>
      <div className={styles["close-button"]} onClick={handleClose}>
        X
      </div>
    </div>
  );
};

export default NotificationPopup;
